// extracted by mini-css-extract-plugin
module.exports = {"mobileBGWrapper":"styles_mobileBGWrapper__3965I","mobileBG":"styles_mobileBG__12Kvw"};